import { useBoolean } from 'react-use';
import { useTranslation } from 'react-i18next';
import { Button } from 'components/Button';
import { Heading, Paragraph } from 'components/Typography';
import config from 'config';

export const LearningCenterFooter: React.FC<{ variant: 'children' | 'adult' }> = ({ variant }) => {
  const [isCopied, toggleCopied] = useBoolean(false);
  const { t } = useTranslation();

  return (
    <>
      {variant === 'children' && (
        <Paragraph className="mb-24 font-bold md:text-lg text-lg">
          {t('screener.results.learningCenter.child.1')}
          <a
            className="underline hover:no-underline"
            href="https://www.expressable.com/learning-center"
            target="_blank"
            rel="noreferrer"
          >
            {t('screener.results.learningCenter.child.2')}
          </a>
          <span>{t('screener.results.learningCenter.child.3')}</span>
        </Paragraph>
      )}

      {variant === 'adult' && (
        <div className="flex sm-d:flex-col sm-d:items-stretch sm-d:gap-40 gap-24 items-center">
          <Heading level="h5" className="leading-7">
            {t(`screener.results.learningCenter.adult`)}
          </Heading>
          <Button
            id="shareBtn"
            size="lg"
            variant="secondary"
            className="shrink-0"
            as="a"
            href="https://www.expressable.com/learning-center"
            target="_blank"
          >
            {t(`screener.results.learnMoreButton`)}
          </Button>
        </div>
      )}

      <hr className="my-64 sm-d:my-40 mb-64 sm-d:mb-40 border-black-200" />

      <div className="flex sm-d:flex-col sm-d:gap-40 sm-d:items-stretch gap-24 items-center mb-128 sm-d:mb-64">
        <div>
          <Heading level="h4" className="mb-16">
            {t(`screener.results.share.title`)}
          </Heading>
          <Heading level="h7">{t(`screener.results.share.subtitle`)}</Heading>
        </div>

        <Button
          id="shareBtn"
          size="lg"
          variant="secondary"
          className="shrink-0"
          disabled={isCopied}
          onClick={() => {
            navigator.clipboard.writeText(`${config.get('screenerAppUrl')}`);
            toggleCopied();
          }}
        >
          {!isCopied ? t(`screener.results.share.copyLinkButton`) : t('screener.results.share.linkCopied')}
        </Button>
      </div>
    </>
  );
};
